import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClickAwayListener } from "@mui/material";
import { BottomNavigation, BottomNavigationAction, Box, Popper, Button } from "@mui/material";
import { navRoutes, isRouteActive } from "../../constants/routes";

export const BottomNav = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  // the active item follows the url, menus that only open a sub menu do not change it
  const activeRoute = navRoutes.find((route) => isRouteActive(route, location.pathname));
  const navIndex = activeRoute ? navRoutes.indexOf(activeRoute) : false;

  // state
  const [subMenu, setSubMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  // sub menu
  const prepareSubRoutes = () => {
    let routeList = [];
    if (!subMenu) return;
    for (let route of subMenu.childrens) {
      routeList.push(
        <Button
          color="primary"
          size={"large"}
          target={"_blank"}
          key={route.index}
          sx={{
            width: "100%",
            justifyContent: "flex-start",
            color: "text.primary",
            borderRadius: "8px",
            "&:hover": { backgroundColor: "background.light", color: "text.primary" },
          }}
          href={route.external ? route.route : null}
          onClick={() => {
            route.external ? null : navigate(route.route);
          }}
        >
          {route.label}
        </Button>
      );
    }
    return routeList;
  };
  const prepareRoutes = () => {
    let routesList = [];
    for (let route of navRoutes) {
      if (route.type == "dropdown") {
        routesList.push(
          <BottomNavigationAction
            key={route.index}
            onClick={(event) => {
              let _menu = route;
              let _anchor = event.currentTarget;
              if (subMenu && subMenu.index == route.index) {
                _menu = null;
                _anchor = null;
              }
              setSubMenu(_menu);
              setAnchorEl(_anchor);
              event.stopPropagation();
            }}
            label={route.label}
          />
        );
      } else {
        routesList.push(
          <BottomNavigationAction
            key={route.index}
            onClick={() => {
              if (subMenu) {
                setSubMenu(null);
                setAnchorEl(null);
              }
              navigate(route.route);
            }}
            label={route.label}
          />
        );
      }
    }
    return routesList;
  };

  return (
    <Box>
      <ClickAwayListener
        onClickAway={() => {
          if (subMenu) {
            setSubMenu(null);
            setAnchorEl(null);
          }
        }}
        disableReactTree={true}
      >
        <Popper id={"sub-menu"} open={!!subMenu} anchorEl={anchorEl}>
          <Box
            sx={{
              mb: 1,
              minWidth: 180,
              p: 0.75,
              borderRadius: "12px",
              border: 1,
              borderColor: "divider",
              backgroundColor: "background.paper",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 16px 40px rgba(0, 0, 0, 0.5)",
            }}
          >
            {prepareSubRoutes()}
          </Box>
        </Popper>
      </ClickAwayListener>

      <BottomNavigation showLabels value={navIndex} sx={props.sx}>
        {prepareRoutes()}
      </BottomNavigation>
    </Box>
  );
};
